const iconHome = `
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16">
  <g fill="none" fill-rule="evenodd">
    <g stroke="#00A3D9" stroke-linecap="round" stroke-linejoin="round" transform="translate(0 1)">
      <polyline points="2.188 7.609 2.188 13.696 5.938 13.696 5.938 9.435 9.063 9.435 9.063 13.696 12.813 13.696 12.813 7.913"/>
      <polyline points=".313 7.304 7.5 .304 14.688 7.304"/>
      <polyline points="10 .913 12.188 .913 12.188 3.043"/>
    </g>
    <rect width="15" height="15"/>
  </g>
</svg>

`;

export default iconHome;
